import _defineProperty from "/builds/speachme/speachmeDesktop/speach-front/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import { __decorate } from "tslib";
import { Component, Prop, Vue } from "vue-facing-decorator";
import { htmliFy } from "@/util/stringUtils";
let wHtmlToolTip = class wHtmlToolTip extends Vue {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "placement", void 0);
    _defineProperty(this, "title", void 0);
    _defineProperty(this, "width", void 0);
    _defineProperty(this, "disabled", void 0);
    _defineProperty(this, "showArrow", void 0);
    _defineProperty(this, "popperClass", void 0);
    _defineProperty(this, "hideAfter", void 0);
    // HTML content of the tooltip
    _defineProperty(this, "label", void 0);
  }
  get sanitizedLabel() {
    return htmliFy(this.label);
  }
};
__decorate([Prop({
  default: 'top-start'
})], wHtmlToolTip.prototype, "placement", void 0);
__decorate([Prop({
  default: ''
})], wHtmlToolTip.prototype, "title", void 0);
__decorate([Prop({
  default: 200
})], wHtmlToolTip.prototype, "width", void 0);
__decorate([Prop({
  default: false
})], wHtmlToolTip.prototype, "disabled", void 0);
__decorate([Prop({
  default: true
})], wHtmlToolTip.prototype, "showArrow", void 0);
__decorate([Prop({
  default: ''
})], wHtmlToolTip.prototype, "popperClass", void 0);
__decorate([Prop({
  default: 200
})], wHtmlToolTip.prototype, "hideAfter", void 0);
__decorate([Prop({
  default: ''
})], wHtmlToolTip.prototype, "label", void 0);
wHtmlToolTip = __decorate([Component({})], wHtmlToolTip);
export default wHtmlToolTip;